import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateContactListMutation } from "@/store/rest_api";
import { toast } from "sonner";
import ContactListForm from "@/components/pages/contact-lists/ContactListForm";
import type ContactList from "@/model/interface/ContactList";

export default function CreateContactListPage() {
  const navigate = useNavigate();
  const [create, { isLoading }] = useCreateContactListMutation();

  // hard guard against double submits (double click, enter spam, etc.)
  const submittingRef = useRef(false);

  const handleSubmit = async (data: Partial<ContactList>) => {
    if (submittingRef.current) {
      return;
    }
    submittingRef.current = true;

    try {
      const created = await create(data).unwrap();
      toast.success("List created");
      navigate(`/contacts/lists/${created.id}/edit`);
    } catch (e: any) {
      toast.error(e?.detail ?? "Failed to create list");
      submittingRef.current = false; // allow retry only on failure
    }
  };

  return (
      <div className="p-4 max-w-2xl mx-auto">
        <ContactListForm onSubmit={handleSubmit} isSubmitting={isLoading} submitLabel="Create List" />
      </div>
  );
}